<template>
  <div class="index-container">
    <div class="index-header"></div>
    <div class="index-nav index-w-1200">
      <div class="index-logo">
        <img src="../assets/images/logo.png">
      </div>
      <div class="index-menu">
        <div class="mobile-menu">
          <router-link to="/">首页</router-link>
          <router-link to="/news">资讯</router-link>
          <a target="_blank" href="http://developer.extscreen.com/">快应用文档中心</a>
        </div>
      </div>
    </div>
    <div class="banner">
      <div class="banner-txt">
        <p>HLTECH·Expansion Screen</p>
        <strong class="title">高光·快应用</strong>
        <strong class="spacingTwice">TV&手机联动快应用引擎</strong>
        <span>JS快速开发、快速上线、零碎片化，帮您打造快速登录千万家庭大屏通道</span>
      </div>
      <div class="banner-pic">
        <img src="../assets/images/banner-pt.png">
      </div>
    </div>

    <div class="news_list">
      <div class="news_item" v-for="(item, index) in list" :key="index" @click="isShowQrcode = true">
        <p class="item_title">{{item.title}}</p>
        <span class="item_desc">{{item.content}}</span>
        <span class="item_tips">付费3元查看更多</span>
      </div>
    </div>

    <footer class="footer">
      <p><a target="_blank" href="/static/service.html">用户协议</a> | <a target="_blank" href="/static/legalC.html">隐私政策</a> | <a target="_blank" href="https://www.yecao.net">野草助手</a></p>
      <p>Copyright © 2019-2021 hiliad.com All rights reserved. 北京汗粮科技有限公司 版权所有 <a href="http://beian.miit.gov.cn">京ICP备19043080号-6</a></p>
    </footer>

    <div class="qrcode_dialog" v-show="isShowQrcode" @click="isShowQrcode = false">
      <img src="../assets/images/news_qrcode.jpg">
    </div>
  </div>
</template>
<script>
export default {
  name: 'web',
  data () {
    return {
      list: [
        {
          title: '优质视频内容如何快速上大屏？',
          content: '使用快应用技术框架，开发有Android原生开发转变为vue开发，能节省开发量70%...'
        },
        {
          title: '快应用服务包括哪几部分？',
          content: '快应用服务主要包含三部分，第一部分为快应用引擎，是vue代码渲染的核心框架...'
        },
        {
          title: '快应用应用跟原生应用的区别是？',
          content: '快应用是针对智能大屏设备的高性能的跨终端开发框架，相比直接在智能电视上安装运行原生APP有以下特点:...'
        }
      ],
      isShowQrcode: false
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/val";
  @import "../assets/global";
  @import "../assets/index.css";
  .news_list {
    max-width: 1000px;
    margin: 40px auto;
    padding: 0 20px;
    .news_item {
      background-color: #f5f6fa;
      border-radius: 5px;
      padding: 20px 30px;
      margin-bottom: 30px;
      cursor: pointer;
      .item_title {
        font-size: 26px;
        font-weight: bold;
      }
      .item_desc {
        color: #666;
        font-size: 18px;
        display: block;
      }
      .item_tips {
        font-size: 18px;
        color: #01aea1;
        font-weight: bold;
      }
    }
  }
  .qrcode_dialog {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(0,0,0,.8);
    z-index: 100;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 300px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/news.vue